import { PythaEngineControl } from "pytha2";
import { useCallback, useState } from "react";

export interface EngineStatus {
    engine?: PythaEngineControl | null; // 当前的引擎实例
    setEngine?: React.Dispatch<React.SetStateAction<PythaEngineControl>>; // 初始化引擎的方法
    cmdValue?: string; // 当前输入的命令值
    setCmdValue?: React.Dispatch<React.SetStateAction<string>>; // 设置命令值的方法
    emitCommand?: (command: string) => void; // 发送命令的方法
    fontSource: opentype.Font,
    setFontSource: (font: opentype.Font) => void
    unit: string,
    setUnit: React.Dispatch<React.SetStateAction<string>>
}

export function useEngineService() {
    const [engine, setEngine] = useState<PythaEngineControl>(null); // 引擎实例
    const [cmdValue, setCmdValue] = useState<string>(""); // 当前命令框的输入值
    const [currentLayerUuid, setCurrentLayerUuid] = useState<string>(); // 当前图层
    // const [mobjectLabel, set]

    /**
     * 显示单位
     */
    const [unit, setUnit] = useState<string>("mm");

    const [fontSource, setFontSource] = useState<opentype.Font>(null)

    // 发送命令到引擎
    const emitCommand = useCallback((command: string) => {
        if (engine) {
            engine.eventMediator.emitEvent({
                cmd: 'CMD',
                data: command,
            });
        }
    }, [engine]);


    return {
        engine,
        setEngine,
        cmdValue,
        setCmdValue,
        emitCommand,
        currentLayerUuid,
        setCurrentLayerUuid,
        fontSource,
        setFontSource,
        unit,
        setUnit,
    } as EngineStatus;
}
